import './ServiceBanner.css';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { handleScroll, whatsAppBotListener } from "../../utils/Utils";
import { CONTACTUS_SECTION_ID, PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/rohan-systems-pics/logo.png';
import ServiceDetailsData from './ServiceDetailsData';

const ServiceBanner = () => {
  const { serviceName } = useParams();
  const serviceKey = serviceName?.toLowerCase();
  const service = ServiceDetailsData[serviceKey];

  return (
    <section className="service-banner-section">
      {service ? (
        <div className="service-banner-content container">
          <h1 className="service-banner-title">{service.title}</h1>
          <p className="service-intro">{service.intro}</p>
          
          <div className='serviceImageDiv'>
            <img src={service.img} className='servicesImage' alt={service.title}/>
          </div>
            {service.sections.map((section, index) => (
              <div key={index} className="service-section-block">
                <h3>{section.heading}</h3>

                <div className="service-points">
                  {section.points.map((point, i) => (
                    <p key={i}>
                      <i className="fas fa-check-circle"></i> {point}
                    </p>
                  ))}
                </div>
              </div>
            ))}

        </div>
      ) : (
        <h2 className="text-center">Service details not available</h2>
      )}
      {/* What's app bot section */}
            <FloatingWhatsApp
                avatar={clinicIcon}
                notification={false}
                accountName="Rohan Sytems"
                phoneNumber={PHONE_NUMBER}
                onSubmit={(e) => {
                    whatsAppBotListener(e.target[0].value);
                }}
            />
    </section>
  );
};

export default ServiceBanner;
